import React, { Component } from "react";
import store from "@/redux/store";
import {addDocument, showConfirmModal, hideModal} from "@/reducers/ModalPopup";
import {removeDocument} from "@/reducers/Document";
import { Link, useNavigate, useLocation } from "react-router-dom";

interface ComponentProps {
  [key: string]: any; //Accept any property
};

export function OverviewDocuments({...props}: ComponentProps): any{

const removeHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));
    
    return false;
  }
const confirmedRemoveHandler = (props) => {
    store.dispatch(removeDocument({...props.item, team: true}));
    store.dispatch(hideModal(null));
}


    const addDocumentPopupHandler = ((event) => {
        store.dispatch( addDocument({isTeam: props?.isTeam, user: props?.user}) );
        return false; 
    });
    return (
        <>
      <div className="sm:flex sm:items-center pt-4">
        <div className="sm:flex-auto">
          <p className="mt-2 text-sm text-gray-700">
            Hier kunt u alle documenten beheren welke gekopeld zijn aan persoon. <br/>
            Persoonsgebonden documenten zoals paspoort, rijbewijs ed zijn en blijven eigendom van de persoon.<br/>De persoon kan deze eventueel delen met uw bedrijf, hiervoor kunt een document aanvraag aan de desbetreffende persoon versturen.
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            onClick={addDocumentPopupHandler}
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Document aanvraag
          </button>
        <br/>        
          <button
            type="button"
            onClick={addDocumentPopupHandler}
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Toevoegen bedrijfsdocument
          </button>
        </div>
      </div>        
        <div className="space-y-10 divide-y divide-gray-900/10">
            <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                        <tr>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                             Document
                          </th>
                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            Type
                          </th>
                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            
                          </th>
                        </tr>
                    </thead>
                    
              <tbody className="divide-y divide-gray-200">
                {props.documents && props.documents.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ item?.name }</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ item?.type }</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {!item.user_document  &&
                        <Link to="" 
                            onClick={(e) => {removeHandler(e, item);}}
                            className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-5">
                                Verwijderen<span className="sr-only">, {item.name}</span>
                      </Link>
                        }
                    </td>
                    </tr>
                ))}
              </tbody>
                </table>
            </div>
        </div>
        </>
    );
}